import { render, staticRenderFns } from "./ComponentProfitTaker.vue?vue&type=template&id=0fe41425"
import script from "./ComponentProfitTaker.vue?vue&type=script&lang=js"
export * from "./ComponentProfitTaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports